import { Box, chakra, Flex } from '@chakra-ui/react'
import { isValidMotionProp, motion } from 'framer-motion'

const MotionBox = chakra(motion.div, {
  shouldForwardProp: (prop) => isValidMotionProp(prop) || prop === 'children',
})

const blobs = [
  {
    size: '30vh',
    delay: 0,
    style: {
      bg: 'brand',
      bottom: -4,
      right: -42,
    },
  },
  {
    size: '28vh',
    delay: 2,
    style: {
      bg: 'accent',
      bottom: -12,
      left: -4,
    },
  },
  {
    size: '30vh',
    delay: 4,
    style: {
      bg: 'highlight',
      top: 0,
      left: -42,
      rotate: 90,
    },
  },
  {
    size: '32vh',
    delay: 2,
    style: {
      bg: 'assertive',
      top: 0,
      right: -4,
    },
  },
]

const Blob = () => {
  return (
    <Box
      pos={'fixed'}
      zIndex={-1}
      top={0}
      blur={'2xl'}
      w={'full'}
      h={'100vh'}
      display={'grid'}
      placeItems={'center'}
      filter={'blur(2rem)'}
      bg={'transparent'}
      bgAttachment={'fixed'}
      bgSize={'cover'}
      bgRepeat={'no-repeat'}
      bgPos={'0 0'}
      bgImage={`url('/static/app-bg.jpg')`}
    >
      <Flex
        pos={'relative'}
        justifySelf={'space-evenly'}
        transform={{ base: 'rotate(45deg)', md: 'rotate(120deg)' }}
        maxW={'4xl'}
        m={'auto'}
      >
        {blobs.map((item, i) => (
          <MotionBox
            key={`blob-${i}`}
            bg={item.style.bg}
            h={item.size}
            w={item.size}
            pos={'absolute'}
            top={item.style.top}
            bottom={item.style.bottom}
            left={item.style.left}
            right={item.style.right}
            borderRadius={'full'}
            mixBlendMode={'multiply'}
            opacity={{ base: 0.05, md: 0.05 }}
            animate={{
              scale: [1, 1.2, 1.4, 1.6, 1],
            }}
            transition={{
              duration: '10',
              delay: item.delay.toString(),
              ease: 'easeInOut',
              repeat: Infinity.toString(),
              repeatType: 'loop',
            }}
          />
        ))}
      </Flex>
    </Box>
  )
}

export default Blob
